import React from 'react';
import PropTypes from 'prop-types';
import DataTableWidget from 'common/components/DataTableWidget';
import PageContainer from 'common/components/PageContainer';
import styles from './styles.module.scss';

const columns = [
  {
    Header: 'מספר דוח',
    accessor: 'firmShumaID', // accessor is the "key" in the data
  },
  {
    Header: ['תאריך יצירה', 'סטטוס'],
    accessor: 'createTime',
  },
  {
    Header: 'גורם מטפל',
    accessor: 'responsibleUser',
  },
  {
    Header: 'כתובת',
    accessor: 'fullAddress',
  },
  {
    Header: 'גוש / וחלקה',
    accessor: 'gushHelka',
  },
  {
    Header: ['סוג דוח', 'סוג הנכס'],
    accessor: 'shumaAndPropertyTypes',
  },
  {
    Header: 'לקוחות',
    accessor: 'customers',
  },
  {
    Header: ' ',
    accessor: 'actions',
  },
];

const InspectedFirmPage = ({
                                 list,
                                 page,
                                 setPage,
                                 getListByFirm,
                                 totalPages,
                                 totalResultCount
                               }) => {
  return (
    <PageContainer>
      <DataTableWidget
        title={' מאגר דוחות המשרד'}
        module={'InspectedFirmList'}
        getListHandler={getListByFirm}
        data={list}
        columns={columns}
        page={page}
        setPage={setPage}
        totalPages={totalPages}
        totalResults={totalResultCount}
        allowSearchByCustomerName={true}
        allowSearchByShumaID={true}
        customClassNames={{
          headerCell: styles.customHeaderCell,
          row: styles.customRow
        }}
      />
    </PageContainer>
  );
};

InspectedFirmPage.propTypes = {
  list: PropTypes.array,
  page: PropTypes.number,
  setPage: PropTypes.func,
  getListByUser: PropTypes.func
};

export default InspectedFirmPage;

